<script lang="ts">
	import { get } from 'svelte/store';
	import { page } from '$app/stores';
	import type { CaseListBlock } from './CaseListBlockQuery';
	import { Endpoint } from '@core/tools/Endpoint.svelte';
	import ThumbListModule from '@comp/ThumbListModule.svelte';
	import { goto } from '$app/navigation';

	let { data, layout }: { data: Omit<CaseListBlock, '_modelApiKey'>; layout?: string } = $props();
	const cases = $state([...get(page).data.globals.allCases]);
	const totalNumOfCases = get(page).data.globals._allCasesMeta.count;
	const endpoint = new Endpoint('/api/v1/cases');
	const showLoadMore = $derived(layout === 'full' && totalNumOfCases > cases.length);
	layout = layout || data.kind;

	const items = $derived.by(() => {
		return cases.map((item) => ({
			description: item.smallDescription,
			media: item.thumbMedia,
			path: `/cases/${item.slug}`
		}));
	});

	if (data.kind === 'reference') {
		cases.splice(4);
	}

	function onViewMore() {
		goto('/cases');
	}
	async function fetchMore() {
		try {
			const result = await endpoint.fetch(
				new URLSearchParams({ skip: cases.length.toString(), first: '4' })
			);
			cases.push(...result.allCases);
		} catch (e) {
			console.error(e);
		}
	}
</script>

<ThumbListModule
	headline={data.headline}
	{layout}
	onViewMore={layout === 'reference' ? onViewMore : undefined}
	onLoadMore={showLoadMore ? fetchMore : undefined}
	{items}
	isLoading={endpoint.isLoading}
	loadMoreText="Se flere cases"
	viewMoreText="Se alle cases"
></ThumbListModule>
